function IconLock({ size = 16, color = '#000' }: { size?: number; color?: string }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.33325 7.33333V4.66667C5.33325 3.95942 5.6142 3.28115 6.1143 2.78105C6.6144 2.28095 7.29267 2 7.99992 2C8.70716 2 9.38544 2.28095 9.88554 2.78105C10.3856 3.28115 10.6666 3.95942 10.6666 4.66667V7.33333M4.66659 7.33333H11.3333C12.0696 7.33333 12.6666 7.93029 12.6666 8.66667V12.6667C12.6666 13.403 12.0696 14 11.3333 14H4.66659C3.93021 14 3.33325 13.403 3.33325 12.6667V8.66667C3.33325 7.93029 3.93021 7.33333 4.66659 7.33333ZM8.66659 10.6667C8.66659 11.0349 8.36811 11.3333 7.99992 11.3333C7.63173 11.3333 7.33325 11.0349 7.33325 10.6667C7.33325 10.2985 7.63173 10 7.99992 10C8.36811 10 8.66659 10.2985 8.66659 10.6667Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

IconLock.displayName = 'IconLock';

export default IconLock;
